import {
  Box,
  Divider,
  Flex,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Step,
  StepDescription,
  StepIndicator,
  StepSeparator,
  StepStatus,
  StepTitle,
  Stepper,
  Td,
  Text,
  Th,
  Tr,
} from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import { FetchInvestigationDetails, FetchLabsDataTableView, FetchLabTestDetails } from "../../middleware/services/messages";
import moment from "moment";
import { actionAccessMain, downloadDocument, getIsDoctor, getLoginID, getPatientId, handleAlphaDotAndSpace, useScreenType } from "../../auth";
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import { useLocation, useNavigate } from "react-router-dom";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";
import { PrimaryButton, PrimaryInput, Toaster } from "../../components";
import DynamicModal from "../../components/dynamic-modal";
import { AddMedicalRecord, DeletePatientLabReport } from "../../middleware/services/messages/uploaddocument";
import TabSection from "../../components/tabs";
import { Footer } from "react-day-picker";
import LabTableView from "./labtableview";
import { GetLabTestName, GetTestResultByLabTestId } from "../../middleware/services/visits/patient-overview";
import ModalRight from "../../components/modal-right";
import DatePicker from "../../components/date-picker";
import { FetchDoctorsByUser } from "../../middleware/services/home";
import SimpleTableLabs from "../../components/simple-table-labs";
import { GetLabList } from "../../middleware/services/billing";

const LabTests = ({id, backFunction}) => {
  const location = useLocation();
  const [patientid, setPatientid] = useState("");
  const [countryIdPatient, setCountryIdPatient] = useState("");
  const [labTestData, setLabTestData] = useState(null); 
  const [tableViewData, setTableViewData] = useState(null); 
  const { isLoading, showLoader, dismissLoader } = useLoader();

        // const [patientCountryId, setPatientCountryId] = useState(null);
  
  useEffect(() => {
    const getCountryId = localStorage.getItem("patientCountryId")
    console.log('patientCountryId: ', getCountryId)
    setCountryIdPatient(getCountryId)
  }, [])

  
  const { showSuccessToast, showErrorToast } = Toaster();

  const [actionAccessPatients , setActionAccessPatients] = useState(null);
    const [appointmentId, setAppointmentId] = useState(null);

  
  useEffect(() => {
    
    setActionAccessPatients(actionAccessMain(4))
    const currentUrl = window.location.href;
    const searchParams = new URLSearchParams(currentUrl.split('?') [1]);
    const searchParamsPage = new URLSearchParams(currentUrl.split('&') [1]);
    const id = searchParams.get('id');
    const page = searchParamsPage.get('page');
    
  
  // Get all parameters
  // const id = urlParams.get('id');
  const getappointmentid = searchParams.get('appointmentid');

  if (getappointmentid) {
    setAppointmentId(getappointmentid); // Make sure you have this state defined
  }
    if(page == 'labTest'){
      navigate("/patientprofile?id="+ id + "&page=" + 'overview')
    }
    setPatientid(id);
    // setCountryIdPatient(patientCountryid)
    // fetchlabtestdata(id)
    // fetchinvestigationdata(id)
    if(getappointmentid) {
      fetchData(id, getappointmentid)
    } else {
      fetchData(id, "")
    }
    
  }, []);

  const [formattedData, setFormattedData] = useState(null);
  const [formattedDataForTableView, setFormattedDataForTableView] =
    useState(null);
  const [fetchedData, setFetchedData] = useState(false);


  const fetchData = async (id, apmtid="") => {
      showLoader();
      try {
        const labsData = await FetchLabsDataTableView({
          patientid: id,
          ...(apmtid && { appointmentid: apmtid }), 
          ...(apmtid && { type: 'ipd' })
        });
        // console.log(labsData, "labsData");
        if (labsData) {
          const data = {
            rows: labsData?.map((item) => ({
              header: item.eventtitle,
              units: item.resultuom,
              values: item.data.map(
                (value) =>
                  `${value.documenturl || ""} ${value.documentdate || ""}`
              ),
              reportid: item.data.map((value) => value.documentid),
              documetURL: item.data.map(
                (value) => value.imagepath + value.documenturl
              ),
              reportname: item.data.map((value) => value.reportname),
              trendcolor: item.data.map((value) => value.trendcolor),
            })),
          };
          setFormattedData(data);
        } else {
          setFormattedData("");
        }

        // const labsDataForReportView = await FetchLabsDataForReportsView(input);
        // // console.log(labsDataForReportView, "Report view");
        // const dataForReportsView = {
        //   rows: labsDataForReportView.map((item) => {
        //     const uniqueURLsAndDatesMap = new Map();
        //     item.data.forEach((value) => {
        //       const { imagepath, documenturl, verifieddate } = value;
        //       if (documenturl) {
        //         uniqueURLsAndDatesMap.set(
        //           imagepath + documenturl,
        //           verifieddate
        //         );
        //       }
        //     });

        //     return {
        //       reportname: item.reportname,
        //       reportdescription:
        //         item.data.length > 0 ? item.data[0].reportdescription : "",
        //       values: item.data.map(
        //         (value) =>
        //           `${value.documenturl || ""} ${value.verifieddate || ""}`
        //       ),
        //       reportid: item.data.map((value) => value.reportid),
        //       documetURL: item.data.map(
        //         (value) => value.imagepath + value.documenturl
        //       ),
        //       verifieddate:
        //         item.data.length > 0 ? item.data[0].verifieddate : "-",
        //       // Extract unique URLs and their associated dates
        //       uniqueURLs: Array.from(uniqueURLsAndDatesMap, ([url, date]) => ({
        //         url,
        //         date,
        //       })),
        //     };
        //   }),
        // };

        // setFormattedDataForReportView(dataForReportsView);

        const dataForTable = {
          rows: labsData.map((item) => ({
            header: item.eventtitle,
            unit: item.resultuom,
            values: item.data.map((value) => ({
              resultvalue: value.resultvalue || "-",
              documentdate: value.verifieddate || "",
              trendcolor: value.trendcolor,
              upper_bound: value.upper_bound,
              lower_bound: value.lower_bound
            })),
          })),
        };
        setFormattedDataForTableView(dataForTable);

        setFetchedData(true);
      } catch (error) {
        console.log(error, " error in fetching labs data");
        // setFetchError(true);
      }
      dismissLoader();
    };

  const fetchinvestigationdata = async (id) => {
      showLoader()
          try {
            const result = await FetchInvestigationDetails({
              patientid: id,
            });
  
            console.log(result)
            if (result != null) {
              setTableViewData(result);
            } else {
              setTableViewData('')
            }
            dismissLoader()
        } catch (error) {
            console.error("Error in home:", error);
          }
        };
  
  const fetchlabtestdata = async (id) => {
    showLoader()
        try {
          const result = await FetchLabTestDetails({
            patientid: id,
          });

          if (result != null) {
            console.log(result)
            setLabTestData(result);
          } else {
            setLabTestData([])
          }
          dismissLoader()
      } catch (error) {
          console.error("Error in home:", error);
        }
      };

      const formatDate = (dateString) => {
        if (!dateString) return "-";
        return moment(dateString).format("Do MMM, YYYY");
      };

      // console.log(patientid, "labTest IDDDDD")
      // console.log(labTestData, "labTest Dataaaaaaa")

      const getIconForExtension = (filename) => {
        if (filename && typeof filename === 'string') {
        const basename = filename.substring(filename.lastIndexOf('/') + 1);
        const extension = basename.slice(basename.lastIndexOf('.') + 1).toLowerCase();
        
        switch (extension) {
          case 'png':
            return '/assets/imgs/png-icon.png';
          case 'jpg':
            return '/assets/imgs/jpg-icon.png';
          case 'jpeg':
            return '/assets/imgs/jpg-icon.png';
          default:
            return '/assets/svgs/pdf-icon.svg'; 
        }
      }
      } 

      const fileInputRef = useRef(null);

      var navigate = useNavigate();

      const handleimageselection = async (e) => {
        e.preventDefault();
        
        
        localStorage.setItem("totalDocumentsSelected", 1); 
        localStorage.setItem("remainingDocuments", 1); 

        const file = e.target.files[0];
        showLoader();
        
        const currentUrl = window.location.href
        const searchParams = new URLSearchParams(currentUrl.split('?')[1]);
        const patientid = searchParams.get('id');

        if(appointmentId) {
          // alert('labTEst hit apointmentid')
          navigate("/uploaddocument", { state: { file , patientid, appointmentId} });
        } else {
          // alert('labTEst hit without aptmtid')
          navigate("/uploaddocument", { state: { file , patientid} });
        }
        // existing
        // navigate("/uploaddocument", { state: { file , patientid} });
        dismissLoader();
      };
      const openUploadLabs = () => {
        fileInputRef.current.click(); 
      }


    
      const dynamicModal = React.useRef();
      const [reportName, setReportName] = useState("");
      const [reportid, setReportid] = useState([]);
      const openDeletePopup = (id, reportname, tab) => {
        // const ids = Array.isArray(reportidArray) ? reportidArray : [reportidArray];
        
        setReportid(id);
    
        // setReportid(reportidArray);
        setReportName(reportname);
        dynamicModal.current.openModal();
      };

      const deletePatientReports = async () => {
        showLoader();
        try {
          // const reportIds = Array.isArray(reportid) ? reportid : [reportid];
          // for (const id of reportIds) {
            const inputForDelete = {
                patientid,
              reportid: [{ "id": reportid }],
            };
    
            var result = await DeletePatientLabReport(inputForDelete);
       
            if(result.output.message == "Successfully Deleted"){
              showSuccessToast("Deleted Report Successfully!");
              let id = getPatientId();
              fetchlabtestdata(id)   
              dismissLoader();
            }
          // }
        } catch (error) {
          console.error(`Error deleting report with reportid: ${reportid}`, error);
        }
        // showSuccessToast("Deleted Reports Successfully")
        dismissLoader();
        dynamicModal.current.closeModal();
      }

// Table view and report view functionality
  const [activeTab, setActiveTab] = useState("TableViewTab");

const handleTabClick = (index) => {
    showLoader();
    switch (index) {
      case 0:
        setActiveTab("TableViewTab");
        // fetchinvestigationdata(patientid)
        break;
        case 1:
          setActiveTab("ReportViewTab");
          fetchlabtestdata(patientid)
        break;
      default:
        break;
    }

    dismissLoader();
  };

  // Enter manually-----------------------------------------------------------
  //Manual Entry Forms
  const enterManually = useRef();
  const [ inputId , setInputId ] = useState("");
  const [rowToDelete, setRowToDelete] = useState(null);
  const [showpatientinfo, setShowPatientInfo] = useState(true);
  const deleteRowModal = useRef();
  const [manualreportname, setManualReportName] = useState(null);
  const screenType = useScreenType()
  const [doctorName, setDoctorName] = useState("");
  const [suggestions, setSuggestions] = useState({});
  const [boolValForSuggestions , setBoolValForSuggestions] = useState(true);
  const [showDocNamesDropdown , setShowDocNamesDropdown] = useState(true)
  const [selectedTestId, setSelectedTestId] = useState(0);
  const [patientInfo, setPatientInfo] = useState({
    name: '',
    age: '',
    doctor_name: '',
    date_of_report: '',
    hospital_name: '',
  });
  const [rows, setRows] = useState([]);
  const initialRow = {
    test_name: '',
    resultvalue: '',
    test_formula: '',
    test_unit: '',
    upper_bound: '',
    lower_bound: '',
  // test_name: '',
  // resultvalue: '',
  // test_unit: '',
};
  const [labTestNames , setLabTestNames] = useState([])
  const openManualForm = async ()=>{
    setShowPatientInfo(true);
    //here
    setRows([])
    setDoctorName("")
    setManualReportName(null)

    try {
      
      let input = {
        // "countryid": getPatientCountryid(),
        "countryid": countryIdPatient,
        "patientid": patientid,
       };
       let result = await GetLabList({ 
          "doctorid":"",
          "type": "lab",
          // "pageno":page,
          // pagesize
        });
      //  let result = await GetLabTestName(input);
       if(result?.output?.data){
        setLabTestNames(result.output.data)
        console.log(result , " result ")
       }else{
        setLabTestNames([]);
        console.log("No labs are available for this doctor")
       }
     
    } catch (error) {
      console.error(`Error in getting lab test names`, error);
    }
    fetchTreatmentTeam();
    // fetchDoctors();
    enterManually.current.openRight();
  }

  const handleTestNameChange = (name, index) => {
    setInputId(index)
    const newRows = [...rows];
    newRows[index].test_name = name;
    if (!name) {
      newRows[index] = { ...initialRow }; // Reset the entire row if medicine name is cleared
    }
    setRows(newRows);
  };
  const handleTestFormulaChange = (result, index) => {
    const newRows = [...rows];
    newRows[index].test_formula = result;
    setRows(newRows);
  };
  const handleLowRangeChange = (result, index) => {
    const newRows = [...rows];
    newRows[index].lower_bound = result;
    setRows(newRows);
  };
  const handleHighRangeChange = (result, index) => {
    const newRows = [...rows];
    newRows[index].upper_bound = result;
    setRows(newRows);
  };
  const handleTestResultChange = (result, index) => {
    const newRows = [...rows];
    newRows[index].resultvalue = result;
    setRows(newRows);
  };
  const handleunitChange = (unit, index) => {
    const newRows = [...rows];
    newRows[index].test_unit = unit;
    setRows(newRows);
  };
  const AddAnotherRowLabTest = () => {
    // const initialRow = {
    //   test_name: '',
    //   resultvalue: '',
    //   test_unit: '',
    // };
    setRows((prevRows) => [...prevRows, { ...initialRow }]);
    focusInput("LabNameInAdd"); // Focus logic
  };
  const PopulateRows = (testDetail) => {
    if(testDetail && testDetail.labmetric) {
        const newRows = testDetail.labmetric.map(metric => ({
            test_name: metric.metricname,
            resultvalue: "",
            test_formula: metric.formula,
            test_unit: metric.unit,
            upper_bound: metric.highrange,
            lower_bound: metric.lowrange,
        }));
        setRows(newRows);
    } else {
        AddAnotherRowLabTest();
    }
    focusInput("LabNameInAdd");
};
  // const PopulateRows = (testDetail) => {
  //   if(labTestDetail){
  //     for(let i = 0; i < testDetail.length; i++){

  //       const initialRow = {
  //         test_name: testDetail[i].eventtitle,
  //         resultvalue: "",
  //         test_unit: testDetail[i].resultuom,
  //         "upper_bound": testDetail[i].upperbound,
  //         "lower_bound": testDetail[i].lowerbound,
  //       };
  //       setRows((prevRows) => [...prevRows, { ...initialRow }]);
  //   }
  //   }
  //   focusInput("LabNameInAdd"); // Focus logic
  // };
  const focusInput = (inputId) => {
    setTimeout(() => {
      const element = document.getElementById(inputId);
      if (element) {
        element.focus();
      }
    }, 100);
  };
  const confirmDeleteRow = (index) => {
    setRowToDelete(index);
    deleteRowModal.current.openModal();
  };
  const deleteRowHandler = () => {
    const newRows = rows.filter((_, i) => i !== rowToDelete);
    setRows(newRows);
    deleteRowModal.current.closeModal();
  };
  const SubmitForm = async () => {
    showLoader();
    const isValidRows = (rows, fieldNames) => {
      for (const row of rows) {
        for (const fieldName of fieldNames) {
          if (!row[fieldName]) {
            dismissLoader();
            // Assuming you have a function to show toast messages
            showErrorToast(`Please fill in the ${fieldName == "test_name"? "Test Name": "Result Value"}`);
            return false;
          }
        }
      }
      return true;
    };
    if (!isValidRows(rows, ['test_name', 'resultvalue'])) return;
      let FinalInput = {
        patient_info:{
          // name: getPatientFullName(),
          // age: getPatientAge(),
          // doctor_name: doctorName,
          // date_of_report: patientInfo.date_of_report ? patientInfo.date_of_report : moment().format("YYYY-MM-DD"),
          // hospital_name: patientInfo.hospital_name,
          patientid: getPatientId(),
          // activeuserid: getUserID(),
        },
        report_info:{
          type:"labs",
          name: manualreportname
        },
        test_list: rows.map((row) => ({
          test_name: row.test_name,
          test_unit: row.test_unit,
          test_formula: row.test_formula,
          resultvalue: row.resultvalue,
          "upper_bound": row.upper_bound,
          "lower_bound": row.lower_bound,
        })),
      };
      showLoader();
      const result = await AddMedicalRecord(FinalInput);
      if (result.output.result === "success") {
        //setShowSuccess(true);
          // fetchPatientHealthData()
          fetchinvestigationdata(patientid)
          fetchData(patientid)
        showSuccessToast("Report added Successfully!")
        enterManually.current.closeRight();
        //setActiveTab("TableViewTab");
        // setTimeout(() => {
          
        //   window.location.reload()
        // }, 500);
        //dismissLoader();
      } else {
        showErrorToast("Somthing went wrong");
        dismissLoader();
      }
  };
  const [ labTestDetail , setLabTestDetail] = useState([]);
  var [DoctorList, setDoctorList] = useState([]);
    var [DoctorListForDropdown, setDoctorListForDropdown] = useState([]);
  // const SubmitPatientForm = async () => {
  //   // if(patientInfo.name == ''){
  //   //   showErrorToast("Please specify your name");
  //   //    return false;
  //   //  }else
  //     if(manualreportname == '' || manualreportname == null){
  //     showErrorToast("Please provide report name!");
  //     return false;
  //   }
  //   else{
  //     try {
      
  //       let input = {
  //         "labtestid":selectedTestId,
  //       // "countryid": getPatientCountryid(),
  //       "countryid": countryIdPatient,
  //       'patientid': patientid

  //        };
  //        let result = await GetTestResultByLabTestId(input);
  //        if(result?.output?.data){
  //         setLabTestDetail(result.output.data)
  //         console.log(result , " result ")
  //         PopulateRows(result.output.data)
  //        }else{
  //         setLabTestDetail([]);
  //         AddAnotherRowLabTest();
  //         console.log("Something went wrong!")
  //        }
       
  //     } catch (error) {
  //       console.error(`Error in getting lab test names`, error);
  //     }
  //     setShowPatientInfo(false)

  //     //here
  //   }
  // };
  const SubmitPatientForm = async () => {
    if(manualreportname == '' || manualreportname == null) {
        showErrorToast("Please provide report name!");
        return false;
    } else {
        try {
            // Find the selected test from labTestNames
            const selectedTest = labTestNames.find(test => test.type === manualreportname);
            
            if (selectedTest) {
                setLabTestDetail(selectedTest);
                PopulateRows(selectedTest);
            } else {
                setLabTestDetail([]);
                AddAnotherRowLabTest();
            }
        } catch (error) {
            console.error(`Error in getting lab test details`, error);
        }
        setShowPatientInfo(false);
    }
};


  const handleSurgeonNameChange = (index, surgeonName) => {
    setInputId(index)
    setDoctorName(surgeonName)
// here
    // Filter surgeon names based on input
    if (surgeonName) {
      filterSurgeonNames(surgeonName);
      setPatientInfo((prev) => ({ ...prev, doctor_name: surgeonName }));
    } else {
    setSuggestions([]);
    setBoolValForSuggestions(!boolValForSuggestions)
    }
  };

  const [doctordata, setDoctorData] = useState("");
    
  const fetchTreatmentTeam = async () => {
    try {
      const result = await FetchDoctorsByUser({
        // "patientid":getPatientId(),
      });
      if (result != null) {
        setDoctorData(result.output.data);
        
      } else {
        //alert("No data");
      }
      dismissLoader();
    } catch (error) {
      console.error("Error in home:", error);
    }
  };

  const filterSurgeonNames = ( surgeonName) => {
    const filtered = doctordata && doctordata.filter((surgeon) =>
      surgeon.fullname?.toLowerCase().includes(surgeonName.toLowerCase())
    );
    setSuggestions(filtered);
    setBoolValForSuggestions(!boolValForSuggestions)  
    if(filtered){
      setShowDocNamesDropdown(true)
    }
  };

  const listOfSurgeonNames = ( isImage) => {
 
    const allSuggestions = doctordata && doctordata
   
  setSuggestions(allSuggestions);
    // setBoolValForSuggestions(!boolValForSuggestions) 
    if(isImage){
      setShowDocNamesDropdown(!showDocNamesDropdown)
      setShowReportNamesDropdown(false)
    }
  };

  const handleSelect = (suggestion) => {
    setDoctorName(suggestion.fullname);
    setSuggestions([]);
  };

  // code for Report Name Dropdown -----------
  
  const [showReportNamesDropdown , setShowReportNamesDropdown] = useState(false)
  const [labTestNamesFiltered , setLabTestNamesFiltered] = useState([]);

  const filterSurgeonNamesReport = ( surgeonName) => {
    const filtered = labTestNames && labTestNames.filter((surgeon) =>
      surgeon.type?.toLowerCase().includes(surgeonName.toLowerCase())
      // surgeon.testname?.toLowerCase().includes(surgeonName.toLowerCase())
    );
    setLabTestNamesFiltered(filtered);
    setBoolValForSuggestions(!boolValForSuggestions)  
    console.log(labTestNames, " labTestNames")
    console.log(filtered, " filtered")
    if(filtered){
      setShowReportNamesDropdown(true)
    }
  };

  const handleReportNameChange = (index, surgeonName) => {
    setInputId(index)
    setManualReportName(surgeonName)

    // Filter surgeon names based on input
    if (surgeonName) {
      filterSurgeonNamesReport(surgeonName);
      // alert(surgeonName)
    setPatientInfo((prev) => ({ ...prev, name: surgeonName }));
    } else {
      
      setLabTestNamesFiltered([]);
      
    setBoolValForSuggestions(!boolValForSuggestions)
    }
  };

  const handleShowListOfTestNames = ( isImage) => {
 
    const allSuggestions = labTestNames && labTestNames
    setLabTestNamesFiltered(allSuggestions);
    // setBoolValForSuggestions(!boolValForSuggestions) 
    if(isImage){
      setShowReportNamesDropdown(!showReportNamesDropdown)
      setShowDocNamesDropdown(false)
    }
  };


  const handleSelectReport = (selectedTest) => {
    setSelectedTestId(selectedTest.id)
    setManualReportName(selectedTest.type);
    // setManualReportName(selectedTest.testname);
    setLabTestNamesFiltered([]);
  };

  const handleDateChange = (selecteddate) => {
    const formattedDate = moment(selecteddate).format('YYYY-MM-DD');
    setPatientInfo((prev) => ({ ...prev, date_of_report: formattedDate }));
  };


  return (
    <>
    {isLoading && <Loader />}
    <Box  display="flex" justifyContent="center" w="100%"  flexDir="column">
    <Box  pos='sticky' p='1rem 1.5rem' alignItems='center' top='0' zIndex='999' bg='white' borderBottom='1px solid #E6E7E9' display="flex" justifyContent="space-between" mb="10px">
    <Text fontWeight='600'>Lab Tests</Text>

{/* New code added */}
      <Box display="flex" gap="10px" alignItems="center" pr="25px">
                  <TabSection
                    tabs={["Table view", "Reports view"]}
                    onClickTab={handleTabClick}
                  />
                  <input
                    type="file"
                    id="file-upload"
                    // onChange={handleimageselection}
                    // ref={fileInputRef} // Set the ref for the file input
                    accept="image/jpeg,image/jpg,image/png,image/tiff,application/pdf"
                    style={{ display: "none" }} // Hide the file input
                  />
                  <PrimaryButton
                    fontSize="14px"
                    variant="mdBtn"
                    buttonText="Enter Manually"
                    btnIcon="/assets/imgs/add.png"
                    onClick={openManualForm}
                  />
                  {formattedData && (
                    <>
                      <PrimaryButton
                      fontSize="14px"
                      variant="mdBtn"
                      buttonText="Upload report"
                      btnIcon="/assets/imgs/add.png"
                      onClick={openUploadLabs}
                      
                      isDisabled={actionAccessPatients?.create ? false : true}
                    />
                        <input
                      type='file'
                      id='file-upload'
                      onChange={handleimageselection}
                      ref={fileInputRef} // Set the ref for the file input
                      accept="image/jpeg,image/jpg,image/png,image/tiff,application/pdf"
                      style={{ display: 'none' }} // Hide the file input
                    /> 
                    </>
                  )}
                </Box>
      </Box>

      <Box>
          <Flex
            bg="#fcfcfd"
            flexDir="column"
            h="calc(100vh - 160px)"
            overflow="hidden auto"
          >
            {formattedData &&
              (activeTab === "TableViewTab" ? (
                <LabTableView TableData={formattedDataForTableView} />
              ) : (
                <Box w="100%" display={{base: "none", lg: "block"}}>
        <Stepper
          orientation="vertical"
          height="100%"
          size="xs"
          colorScheme="#CDCFD4"
          gap="0"
          padding='1.5rem'
          w="100%"
          h='calc(100vh - 140px)'
          overflow='hidden auto'
        >
           
          {Array.isArray(labTestData)  && labTestData.length>0 ? (
              labTestData.map((lab,index) => (
            <Step w="100%">
              <StepIndicator color="#E6E7E9" />
              <Box flexShrink="0" w="95%">
                <StepTitle
                  fontSize="0.75rem"
                  fontWeight="500"
                  color="#384052"
                  mb="0.5rem"
                  key={index}
                >
                  {formatDate(lab.uploadeddate)}
                  {/* {formatDate(lab.verifieddate)} */}
                </StepTitle>
                <StepDescription
                  bg="white"
                  w="100%"
                  border="1px solid #E6E7E9"
                  borderRadius="0.65rem"
                  p="1rem"
                  mb="1.5rem"
                  boxShadow="0px 8px 20px 0px #E6E7E966"
                >
                    <Box>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="flex-start"  // Changed from center to flex-start for better alignment
                        pb="0.5rem"
                      >
                        <Box>
                          <Text fontSize="0.875rem" color="#061027" fontWeight="600">
                            {lab.reportname}
                          </Text>
                          <Text fontSize="0.875rem" color="#061027" mt="0.25rem">
                            {formatDate(lab.verifieddate)}
                          </Text>
                        </Box>
                        
                        {/* Delete Button */}
                        <Box display='flex' gap='0.5rem'>
                          <Box
                            as="button"
                            border="1px solid #E6E7E9"
                            borderRadius="full"
                            w="36px"
                            h="auto"
                            p="10px"
                            onClick={() => openDeletePopup(lab.reportid, lab.reportname, "labs")}
                            disabled={actionAccessPatients?.delete ? false : true}
                            opacity={actionAccessPatients?.delete ? 1 : 0.5}
                          >
                            <Image w="13px" src="/assets/imgs/delete.png" />
                          </Box>
                        </Box>
                      </Box>
                      <Box
                        bg="#F9FAFB"
                        borderLeft="2px solid #14C585"
                        p="0.5rem"
                      >
                        <Text
                          fontSize="0.875rem"
                          fontWeight="500"
                          color="#384052"
                        >
                          {/* Plan: Basic metabolic panel, Magnesium */}
                          {lab.reportdescription}
                        </Text>
                      </Box>

                      <Divider my="1rem" />
                      <Box display="flex" gap="0.75rem">
                      {lab.documenturl != null ? (
                      <>
                        <Box
                          display="flex"
                          gap="0.5rem"
                          p="0.5rem 1rem"
                          bg="white"
                          border="1px solid #E6E7E9"
                          // borderRadius="0.65rem"
                          cursor='pointer'
                          // onClick={()=>downloadDocument(lab.imagepath + lab.documenturl, "report")}
                          onClick={() => downloadDocument(`${lab.imagepath}${lab.documenturl}`, `report.${lab.documenturl.split('.').pop()}`)}
                          borderRadius= '10px 0 0 10px'
                          >
                          <Image
                            w="1.125rem"
                            h="auto"
                            // src="/assets/svgs/pdf-icon.svg"
                            src={getIconForExtension(lab.documenturl)}
                          />
                          <Text fontSize="0.75rem" fontWeight="600">
                            {/* Prescription.pdf */}
                            {/* {`${lab.imagepath}${lab.documenturl}`} */}
                            {`Document- ${index + 1}`}
                          </Text>
                        </Box>

                        <Box
                            display="flex"
                            gap="0.5rem"
                            p="0.5rem 0.5rem"
                            bg="white"
                            border="1px solid #E6E7E9"
                            // borderRadius="0.65rem"
                            cursor='pointer'
                            // onClick={() => {window.open(
                            //   lab.imagepath + lab.documenturl, '_blank')}
                            // }
                            onClick={() => {
                              const previewUrl = `${lab.imagepath}${lab.documenturl}`;
                              // console.log("Preview URL:", previewUrl);
                              window.open(previewUrl, '_blank');
                            }}
                            position= 'relative'
                            left= '-13px'
                            alignItems='center'
                            borderRadius= '0 10px 10px 0'
                            >
                              <Image
                              w="1.125rem"
                              // h="auto"
                              src="/assets/imgs/show-pass.png"
                              />
                          </Box>
                      </>   
                      ) : ('')}
                      </Box>
                    </Box>

                </StepDescription>
              </Box>

              
              <StepSeparator colorScheme="red" />
              </Step>
            ))

          ) : (
            <Box
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            gap="10px"
                            alignItems="center"
                            h="calc(100vh - 100px)"
                            w="100%"
                          >
                            <Box textAlign="left" fontSize="16px" fontWeight="600">
                              <Image
                                w="26px"
                                opacity="0.5"
                                src="/assets/imgs/biotech.png"
                              />
                            </Box>
                            <Text textAlign="left" fontSize="12px" fontWeight="500">
                              No Data available
                            </Text>
                          </Box>
          )}
        </Stepper>
      </Box>
              ))}
            {formattedData == "" && (
              <Box
                w="100%"
                h="100vh"
                display="flex"
                flexDirection="column"
                gap="5px"
                justifyContent="center"
                alignItems="center"
              >
                <Image w="60px" src="/assets/svgs/biotech.svg" />
                <Box as="p">No data available</Box>

                <PrimaryButton
                  fontSize="14px"
                  variant="mdBtn"
                  buttonText="Upload report"
                  btnIcon="/assets/imgs/add.png"
                  onClick={openUploadLabs}
                />
                <input
                      type='file'
                      id='file-upload'
                      onChange={handleimageselection}
                      ref={fileInputRef} // Set the ref for the file input
                      accept="image/jpeg,image/jpg,image/png,image/tiff,application/pdf"
                      style={{ display: 'none' }} // Hide the file input
                    /> 
              </Box>
            )}
          </Flex>
        </Box>
        
      </Box>


      <DynamicModal
        ref={dynamicModal}
        modalHeader="Delete report?"
        modalBody={
          <>
            <Text fontSize="14px" fontWeight="600">
              Are you sure you want to delete  <strong>"{reportName}"</strong>
            </Text>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="deleteBtn"
              buttonText="Delete"
              onClick={deletePatientReports}
            />
          </>
        }
      />

      <ModalRight
        ref={enterManually}
        modalWidth={showpatientinfo ? "600px": "70vw"}
        bodyStyle={{ overflow: "hidden" }}
        header="Manual Report"
        hasFooter={true}
        body={
          <>
          {showpatientinfo ?(
            <Box overflowY="auto" p="24px" h="100%">
            <Box as="h1" fontSize="18px" pb="20px" fontWeight="600">
              Please fill in the details below
            </Box>
            <Box display="flex" alignItems="center" position="relative">
            <PrimaryInput
              variant="bothSide"
              inputType="text"
              inputPlace="Doctor Name"
              inputValue={doctorName}
              onChange={(e) =>
                handleSurgeonNameChange(1, handleAlphaDotAndSpace(e.target.value, 50))
              }
              onClick={() =>
                listOfSurgeonNames(true)
              }
              //if the inputIdProp have id then it will focus, if id is null it will not focus, 
              inputIdProp={inputId == 1 ? "Active" : null}
              boolProp={boolValForSuggestions}
            /> 
               <Image top="35%" right="3.5%" w="15px"  cursor="pointer" position="absolute"
                          onClick={() =>
                            listOfSurgeonNames( true)
                          }
                            pos='absolute' src="/assets/imgs/double-arrow.png" />
                            </Box>
                          
                    {showDocNamesDropdown &&  suggestions.length > 0 && (
                <Menu isOpen={true}>
                <MenuButton as={Box} w="100%" display="block" pos="relative" zIndex="999">
                  <Box pos="absolute" top="100%" left="0" w="100%" bg="white" borderTop="none" border="1px solid #E6E7E9" borderRadius="0 0 12px 12px" />
                </MenuButton>
                <MenuList w="100%" borderRadius="0 0 12px 12px" zIndex="999" bg="white" maxH="150px" overflow="hidden auto">
                  {suggestions.map((suggestion, index) => (
                    <MenuItem
                      key={index}
                      onClick={() => handleSelect(suggestion)}
                      cursor="pointer"
                      p="1rem"
                      py="0.5rem"
                      borderBottom="1px solid #E6E7E9"
                    >
                      <Text fontSize="0.875rem" fontWeight="500">{suggestion.fullname}</Text>
                    </MenuItem>
                  ))}
                  </MenuList>
                </Menu>
              )}

            <DatePicker
              name="date_of_report"
              disableFutureDates={true}
              placeholderProp="Date of Report"
              leftPos={{ left: '3px' }}
              onDateChange={(selectedDateValue) =>
                handleDateChange(selectedDateValue)
              }
              defaultDate={moment().format("DD-MM-YYYY")}
            />
<Box display="flex" alignItems="center" position="relative">
<PrimaryInput
              variant="bothSide"
              inputType="text"
              inputPlace="Report Name*"
              inputValue={manualreportname}
              onChange={(e) =>
                handleReportNameChange(2, handleAlphaDotAndSpace(e.target.value, 50))
              }
              onClick={() =>
                handleShowListOfTestNames(true)
              }
              //if the inputIdProp have id then it will focus, if id is null it will not focus, 
              inputIdProp={inputId == 2 ? "Active" : null}
              boolProp={boolValForSuggestions}
            /> 
               <Image top="35%" right="3.5%" w="15px"  cursor="pointer" position="absolute"
                          onClick={() =>
                            handleShowListOfTestNames( true)
                          }
                            pos='absolute' src="/assets/imgs/double-arrow.png" />
          </Box>
                          
                    {showReportNamesDropdown &&  labTestNamesFiltered.length > 0 && (
                <Menu isOpen={true}>
                <MenuButton as={Box} w="100%" display="block" pos="relative" zIndex="999">
                  <Box pos="absolute" top="100%" left="0" w="100%" bg="white" borderTop="none" border="1px solid #E6E7E9" borderRadius="0 0 12px 12px" />
                </MenuButton>
                <MenuList w="100%" borderRadius="0 0 12px 12px" zIndex="999" bg="white" maxH="150px" overflow="hidden auto">
                  {labTestNamesFiltered.map((suggestion, index) => (
                    <MenuItem
                      key={index}
                      onClick={() => handleSelectReport(suggestion)}
                      cursor="pointer"
                      p="1rem"
                      py="0.5rem"
                      borderBottom="1px solid #E6E7E9"
                    >
                      <Text fontSize="0.875rem" fontWeight="500">{suggestion.type}</Text>
                      {/* <Text fontSize="0.875rem" fontWeight="500">{suggestion.testname}</Text> */}
                    </MenuItem>
                  ))}
                  </MenuList>
                </Menu>
              )}
          </Box>
          ):(
            <SimpleTableLabs
                NoDataHeader={false}
                isDataPresent={true}
                ThStyle={{ textAlign: "center", bg: "#FAFAFA" }}
                tableStyle={{
                  h: "calc(100vh - 170px)",
                  maxH: "calc(100vh - 170px)",
                  overflowY: "auto",
                  overflowX: "hidden",
                  width: "100%",
                  border: "1px solid #E6E7E9",
                  borderBottom: "none",
                }}
                // tableHeaders={
                //   <Tr bg='white' zIndex='9999' pos='relative'>
                //     <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                //       Test name
                //     </Th><Th fontSize="0.87rem" fontWeight="500" pl="10px">
                //       Unit
                //     </Th>
                //     <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                //       Result
                //     </Th>
                //     <Th fontSize="0.87rem" fontWeight="500" >
                //       <Flex w="100%" justifyContent="center" alignItems="center">
                //         <PrimaryButton
                //           btnIcon="/assets/svgs/add-white.svg"
                //           iconSrc={true}
                //           btnStyle={{ w: "25px", h: "25px", p: "0",m:"0" }}
                //           iconSrcStyle={{ mr: "0", w: "10px" }}
                //           onClick={AddAnotherRowLabTest}
                //         />
                //       </Flex>
                //     </Th>
                //   </Tr>
                // }
                tableHeaders={
    <Tr bg='white' zIndex='9999' pos='relative'>
        <Th fontSize="0.87rem" fontWeight="500" pl="10px">Test name</Th>
        <Th fontSize="0.87rem" fontWeight="500" pl="10px">Unit</Th>
        <Th fontSize="0.87rem" fontWeight="500" pl="10px">Low Range</Th>
        <Th fontSize="0.87rem" fontWeight="500" pl="10px">High Range</Th>
        <Th fontSize="0.87rem" fontWeight="500" pl="10px">Formula</Th>
        <Th fontSize="0.87rem" fontWeight="500" pl="10px">Result</Th>
        <Th fontSize="0.87rem" fontWeight="500">
            <Flex w="100%" justifyContent="center" alignItems="center">
                <PrimaryButton
                    btnIcon="/assets/svgs/add-white.svg"
                    iconSrc={true}
                    btnStyle={{ w: "25px", h: "25px", p: "0",m:"0" }}
                    iconSrcStyle={{ mr: "0", w: "10px" }}
                    onClick={AddAnotherRowLabTest}
                />
            </Flex>
        </Th>
    </Tr>
}
// And update the tableBody to include the new fields:
tableBody={
    <>
        {rows?.map((row, index) => (
            <Tr w="100%">
                <Td p="0">
                    <PrimaryInput
                        variant="bothSide"
                        inputPlace="Test name"
                        inputValue={row.test_name}
                        id={index === rows.length - 1 ? "LabNameInAdd" : null}
                        onChange={(e) => handleTestNameChange(e.target.value, index)}
                        autocomplete="off"
                        inputCssStyle={{
                            _hover: { border: "1px solid", borderRadius: "10px" },
                        }}
                        maxLength={100}
                    />
                </Td>
                <Td p="0">
                    <PrimaryInput
                        variant="bothSide"
                        inputPlace='Unit'
                        inputValue={row.test_unit}
                        onChange={(e) => handleunitChange(e.target.value, index)}
                        maxLength={10}
                        inputCssStyle={{
                            _hover: { border: "1px solid", borderRadius: "10px" },
                        }}
                    />
                </Td>
                <Td p="0">
                    <PrimaryInput
                        variant="bothSide"
                        inputPlace="Low Range"
                        inputValue={row.lower_bound}
                        onChange={(e) => handleLowRangeChange(e.target.value, index)}
                        // isDisabled={true}
                        inputCssStyle={{
                            _hover: { border: "1px solid", borderRadius: "10px" },
                        }}
                    />
                </Td>
                <Td p="0">
                    <PrimaryInput
                        variant="bothSide"
                        inputPlace="High Range"
                        inputValue={row.upper_bound}
                        onChange={(e) => handleHighRangeChange(e.target.value, index)}
                        // isDisabled={true}
                        inputCssStyle={{
                            _hover: { border: "1px solid", borderRadius: "10px" },
                        }}
                    />
                </Td>
                <Td p="0">
                    <PrimaryInput
                        variant="bothSide"
                        inputPlace="Formula"
                        inputValue={row.test_formula}
                        onChange={(e) => handleTestFormulaChange(e.target.value, index)}
                        inputCssStyle={{
                            _hover: { border: "1px solid", borderRadius: "10px" },
                        }}
                        maxLength={30}
                    />
                </Td>
                <Td p="0">
                    <PrimaryInput
                        variant="bothSide"
                        inputPlace="Result"
                        inputValue={row.resultvalue}
                        onChange={(e) => handleTestResultChange(e.target.value, index)}
                        inputCssStyle={{
                            _hover: { border: "1px solid", borderRadius: "10px" },
                        }}
                        maxLength={30}
                    />
                </Td>
                <Td p="0">
                    <Box
                        as="button"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        w="100%"
                        onClick={() => confirmDeleteRow(index)}
                    >
                        <Image src="/assets/svgs/delete.svg" opacity="0.7" />
                    </Box>
                </Td>
            </Tr>
        ))}
    </>
}
                // tableBody={
                //   <>
                //     {rows?.map((row, index) => (
                //       <Tr w="100%">
                //         <Td p="0">
                //           <Box w="100%" pos="relative" cursor="pointer">
                //             <PrimaryInput
                //               variant="bothSide"
                //               inputPlace="Test name"
                //               inputValue={row.test_name}
                //               id="LabNameInAdd"
                //               onChange={(e) =>
                //                 handleTestNameChange(
                //                   e.target.value,
                //                   index
                //                 )
                //               }
                //               autocomplete="off"
                //               inputCssStyle={{
                //                 _hover: {
                //                   border: "1px solid",
                //                   borderRadius: "10px",
                //                 },
                //               }}
                //               maxLength={100}
                //             />
                //           </Box>
                        
                //         </Td>
                //         <Td p="0">
                //           <PrimaryInput
                //             variant="bothSide"
                //             inputPlace='Unit'
                //             inputValue={row.test_unit}
                //             onChange={(e) =>
                //               handleunitChange(e.target.value, index)
                //             }
                            
                //             maxLength={10}
                //             inputCssStyle={{
                //               _hover: { border: "1px solid", borderRadius: "10px" },
                //             }}
                //           />
                //         </Td>

                //         <Td p="0">
                //           <PrimaryInput
                //             variant="bothSide"
                //             inputPlace="Result"
                //             inputValue={row.resultvalue}
                //             onChange={(e) =>
                //               handleTestResultChange(e.target.value, index)
                //             }
                //             inputCssStyle={{
                //               _hover: { border: "1px solid", borderRadius: "10px" },
                //             }}
                //             //isDisabled={true}
                //             maxLength={30}
                //           />
                //         </Td>
                  

                //         <Td p="0">
                //           <Box
                //             as="button"
                //             display="flex"
                //             justifyContent="center"
                //             alignItems="center"
                //             w="100%"
                //             //  onClick={() => confirmDeleteRow(index)}
                //           >
                //             <Image src="/assets/svgs/delete.svg" opacity="0.7" />
                //           </Box>
                //         </Td>
                //       </Tr>
                      
                //      ))} 
                //   </>
                // }
            />
          )}
            
            {/* Table data end */}
          </>
        }
        footerActions={
          <>
          {showpatientinfo ?(
            <PrimaryButton buttonText="Next" onClick={SubmitPatientForm}/>
          ):(
            <PrimaryButton buttonText="Submit" onClick={SubmitForm}/>
          )}
          </>
        }
      />
      
<DynamicModal
        ref={dynamicModal}
        modalHeader="Delete report?"
        modalBody={
          <>
            <Text fontSize="14px" fontWeight="600">
              Are you sure you want to delete  <strong>"{reportName}"</strong>
            </Text>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="deleteBtn"
              buttonText="Delete"
              onClick={deletePatientReports}
            />
          </>
        }
      />

      <DynamicModal
              ref={deleteRowModal}
              modalHeader="Delete row"
              modalBody={
                <>
                  <Text fontSize="14px" fontWeight="600">
                    Are you sure you want to delete?
                  </Text>
                </>
              }
              modalFooterBtn={
                <>
                  <PrimaryButton
                    variant="deleteBtn"
                    buttonText="Delete"
                    onClick={deleteRowHandler}
                  />
                </>
              }
            />



      {/* Mobile responsive */}
      <Box w="100%" display={{base: "block", lg: "none"}}>
        <MobileSecondaryNav
          header="Lab test"
          handlebackarrow={backFunction}
        />

        <Box h="calc(100vh - 120px)" overflow='hidden auto' p="1rem">
          <Stepper
            orientation="vertical"
            height="100%"
            size="xs"
            colorScheme="#CDCFD4"
            gap="0"
            w="100%"
          >
            {labTestData && labTestData.length>0 ? (
                labTestData.map((lab,index) => (
              <Step w="100%">
                <StepIndicator color="#E6E7E9" />
                <Box flexShrink="0" w="95%">
                  <StepTitle
                    fontSize="0.75rem"
                    fontWeight="500"
                    color="#384052"
                    mb="0.5rem"
                    key={index}
                  >
                    {/* 10th Jan, 2024 */}
                    {formatDate(lab.verifieddate)}
                  </StepTitle>
                  <StepDescription
                    bg="white"
                    w="100%"
                    border="1px solid #E6E7E9"
                    borderRadius="0.65rem"
                    p="1rem"
                    mb="1.5rem"
                    boxShadow="0px 8px 20px 0px #E6E7E966"
                  >
                      <Box>
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          pb="0.5rem"
                        >
                          <Text fontSize="0.875rem" color="#061027">
                            {/* Heart failure with preserved ejection fraction,
                            unspecified HF chronicity (CMS/HCC) */}
                            {lab.reportname}
                          </Text>
                        </Box>
                        <Box
                          bg="#F9FAFB"
                          borderLeft="2px solid #14C585"
                          p="0.5rem"
                        >
                          <Text
                            fontSize="0.875rem"
                            fontWeight="500"
                            color="#384052"
                          >
                            {/* Plan: Basic metabolic panel, Magnesium */}
                            {lab.reportdescription}
                          </Text>
                        </Box>

                        <Divider my="1rem" />
                        <Box display="flex" gap="0.75rem">
                          <Box
                            display="flex"
                            gap="0.5rem"
                            p="0.5rem 1rem"
                            bg="white"
                            border="1px solid #E6E7E9"
                            borderRadius="0.65rem"
                            cursor='pointer'
                            onClick={()=>downloadDocument(lab.imagepath + lab.documenturl, "report")}>
                            <Image
                              w="1.125rem"
                              h="auto"
                              // src="/assets/svgs/pdf-icon.svg"
                              src={getIconForExtension(lab.documenturl)}
                            />
                            <Text fontSize="0.75rem" fontWeight="600">
                              {/* Prescription.pdf */}
                              {/* {`${lab.imagepath}${lab.documenturl}`} */}
                              {`Document- ${index + 1}`}
                            </Text>
                          </Box>
                        </Box>
                      </Box>

                  </StepDescription>
                </Box>

                
                <StepSeparator colorScheme="red" />
                </Step>
              ))

            ) : (
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                gap="10px"
                alignItems="center"
                h="calc(100vh - 100px)"
                w="100%"
              >
                <Box textAlign="left" fontSize="16px" fontWeight="600">
                  <Image
                    w="26px"
                    opacity="0.5"
                    src="/assets/imgs/biotech.png"
                  />
                </Box>
                <Text textAlign="left" fontSize="12px" fontWeight="500">
                  No Data available
                </Text>
              </Box>
            )}
          </Stepper>
        </Box>
      </Box>
    </>
  );
};

export default LabTests;
